import * as React from "react";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";
import Spinner from "../common/spinner";
import MiniSpinner from "../common/MiniSpinner";

class AppointmentType extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.AppointmentType.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    goToNextStep = (visitType) => {
        const { getAppointmentType, goNext } = this.props;
        if (getAppointmentType) getAppointmentType(visitType);
        if (goNext) goNext();
    }

    videoVisitCard(visitType, index) {
        const displayName = visitType.label;
        return (
            <div className="col-md-6" key={index}>
                <div className="card docs" onClick={(e) => this.goToNextStep(visitType)} >
                    <div className="featured-feature">FEATURED</div>
                    <div className="card-header">
                        <div className="row">
                            <div className="col-12">
                                <div className="card-heading"><div className="svg-video-visit" /><div className="title">{displayName}</div></div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 video-visit-body">
                                Virtual: Use a camera enabled device for a face-to-face appointment with your doctor.
                                    </div>
                        </div>
                    </div>
                </div>
            </div>);
    }

    visitTypeCard(visitType, index) {
        const displayName = visitType.label;
        if (displayName === "Video Visit")
            return this.videoVisitCard(visitType, index);
        else
            return (
                <div className="col-12 col-md-6" key={index}>
                    <div className="card docs" onClick={(e) => this.goToNextStep(visitType)} >
                        <div className="card-header">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card-heading">{displayName}</div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    {displayName}: A complete {displayName} exam.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
    }

    orderVisitsByVirtual = () => {
        const { visitTypes } = this.props;       
        const virtualVisits = [], otherVisits = [];
        let result = [];
        if (visitTypes) {
            visitTypes.map((visit, index) => {
                if (visit && visit.value && visit.label === "Video Visit") {
                    virtualVisits.push(visit);
                }
                else
                    otherVisits.push(visit);
                
            });
            result = [...virtualVisits, ...otherVisits];           
        }
        return result;
    }


    render() {
        const { visitTypes, visitTypeAndLocationPending, safeCareMsg} = this.props;
        const visitsOrderByVirtual = this.orderVisitsByVirtual();
        
        return (
            <div className="schedule-appointment-type-container" style={this.props.style}>
               
                    <React.Fragment>
                        <div className="row">
                            <div className="col-12">
                                <h1 className="step-heading">What appointment would you like to schedule?</h1>
                                <div className="step-description">{safeCareMsg}</div>
                            </div>
                        </div>
                        {visitTypeAndLocationPending
                        ? <React.Fragment>
                            <Spinner />
                            <div className="row">
                                <div className="col-12 text-center">
                                    <MiniSpinner />
                                </div>
                            </div>
                        </React.Fragment>
                        : visitTypes.length === 0 ?
                            <div className="row"><div className="col-12 no-types">Sorry, we’re not able to display visit types. Please try again later.</div></div>
                            : <div className="row row-card-eq">
                                {
                                    visitsOrderByVirtual && visitsOrderByVirtual.map((visitType, index) => {
                                        return this.visitTypeCard(visitType, index);
                                    })
                                }
                            </div>
                        }
                    </React.Fragment>
               
            </div>
        );
    }
}

export default AppointmentType;